import { ADMIN, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const comingSoonApi = {
  read: () =>
    ifyouApi
      .get(`${ADMIN}/comming-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detail: (id) =>
    ifyouApi
      .get(`${ADMIN}/${id}/comming-detail`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (formData) =>
    ifyouApi
      .post(`${ADMIN}/comming-update`, formData, {
        header: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  delete: (id) =>
    ifyouApi
      .post(`${ADMIN}/comming-delete`, {
        comming_id: id,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
